// version.js
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';